import { BudgetModel, BudgetModelMiniDTO } from "../../pojo/bm-classes";
import { DateService } from "../../../../../util/common/date.service";

export class BmGeneralService {

  /**
   * Creates string for models selector in format 'Created by Ivan Z. 2025-04-30 04:20'
   * @param model main model data in {@link BudgetModelMiniDTO} or in {@link BudgetModel} format
   */
  public static createSelectorText(model: BudgetModelMiniDTO | BudgetModel): string {
    const created = DateService.createUTCDate(model.createdDate.toString());
    const modified = DateService.createUTCDate(model.lastModifiedDate.toString());

    created.setMilliseconds(0);
    modified.setMilliseconds(0);

    const isCreated = created.getTime() === modified.getTime();
    const userDate = DateService.createUTCDate(model.lastModifiedDate.toString(), true).toString();
    return (isCreated ? 'Created' : 'Updated')
      + (model.createdBy ? (' by ' + model.createdBy) : '') + ': '
      + DateService.formatLocalDateTime(userDate);
  }
}
